import { normalizePath, useSetFlowTo } from 'Simple/Flow'
import mutationAddAutomation from './mutation.graphql.js'
import { useMutation } from 'Data/Api'
import { useDataValue } from 'Simple/Data'
import { uuid } from 'Data/validate'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications'

/*
 * We have a situation where the connection.id can be an uuid when the data come from `apps_connections` or
 * it can be the connection name when it comes from the json metadata
 * This helper gets the connection name that I need for the action
 * */
function getConnectionName(connection) {
  return uuid(connection.id) ? connection.name : connection.id
}

function validate(value) {
  return value
    .map(({ event }) => {
      if (!event?.data) {
        return null
      }
      switch (event.type) {
        case 'txs_status_update': {
          if (!event.data.value_to) {
            return 'Please select treatment status'
          }

          break
        }
        case 'appointment_bookings_state_update': {
          if (
            !event.data.value_to ||
            !event.data.appointment_type_ids?.length
          ) {
            return 'Please select appointment types and status'
          }

          break
        }
        case 'custom_resource_insert': {
          if (!event.data.custom_resource_type) {
            return 'Please select the custom resource type'
          }
          break
        }

        default:
          return null
      }

      return null
    })
    .filter(Boolean)
}

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let connection = useDataValue({
    viewPath: props.viewPath,
    context: 'connection',
  })
  let location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location._id',
  })

  let [, executeAddAutomationMutation] = useMutation(mutationAddAutomation)
  let setFlow = useSetFlowTo(props.viewPath)
  let [, notify] = useNotifications()

  return async function onSubmit({ value, originalValue, args, change }) {
    let errorMessages = validate(value)

    if (errorMessages?.length) {
      return notify(notifyError(errorMessages.join('\n')))
    }

    let mutationResponse = await executeAddAutomationMutation({
      connection_name: getConnectionName(connection),
      location_id,
      events: value.map(({ event, required }) => ({ ...event, required })),
      app_id: connection.app_id,
    })

    if (mutationResponse.error) {
      notify(
        notifyError(
          'Something went wrong. Please, try again or contact support if the problem persists.'
        )
      )

      return
    }

    setFlow(normalizePath(props.viewPath, '../No'))

    return notify(notifySuccess('The application was connected successfully'))
  }
}
